<template>
  <c-page-tabs v-model="tabName" class="w-page-tabs" show-pane :tab-items="tabItems" @change="handleChange">
    <template #default="item">
      <widget :schema="item.body" />
    </template>
  </c-page-tabs>
</template>

<script setup lang="ts">
import { computed, ref, tpl, useCurrentAppInstance, onMounted, onBeforeUnmount, watch } from '@zto/zpage'
import { UI_GLOBAL_EVENTS, UI_PAGE_EVENTS } from '../../consts'

const props = defineProps<{
  schema: Record<string, any>
}>()

const app = useCurrentAppInstance()

const emitter = app.emitter
const wSchema = app.useWidgetSchema(props.schema)
const cTabItems = app.useWidgetSchema(wSchema.items)
const route = app.useRoute()

// ---- tab相关 ----->
// 如果route携带参数defaultTabName，则默认选中此tab页，否则取设置的默认
const defaultTabName = route.query['defaultTabName'] as string || app.filter(wSchema.default)
// console.log('defaultTabName===', defaultTabName)

const tabName = ref<string>(defaultTabName)

const tabItems = computed(() => {
  return cTabItems || []
})

// 触发页面Tab变化全局事件
function handleChange(item: any) {
  emitter.emit(UI_GLOBAL_EVENTS.PAGE_TAB_CHANGE, {
    name: wSchema.name,
    tabItem: item
  })
}

let CacheDefaultTabName: any = ref()
const setTabName = async () => {
  // 如果route携带参数defaultTabName，则默认选中此tab页，否则取设置的默认
  const defaultTabName = route.query['defaultTabName'] as string || app.filter(wSchema.default)
  if (CacheDefaultTabName.value === defaultTabName) {
    return false
  }
  tabName.value = defaultTabName
  CacheDefaultTabName.value = defaultTabName

  // console.log('CacheDefaultTabName===', CacheDefaultTabName.value)
}

// 激活事件
let activeEvent: any = undefined

onMounted(() => {
  setTabName()
  // 监听UI_PAGE_EVENTS.ACTIVATED（当前页激活）事件触发的回调
  activeEvent = app.ons(UI_PAGE_EVENTS.ACTIVATED, setTabName)
})

onBeforeUnmount(() => {
  // 解除监听UI_PAGE_EVENTS.ACTIVATED（当前页激活）事件触发的回调
  activeEvent && app.offs(activeEvent.eventTypes, activeEvent.handler)
})

// 监听路由defaultTabName是否变化，变化且有值，重新赋值
// watch(
//   () => route.query['defaultTabName'],
//   (val) => {
//     // console.log('val===', val)
//     val && (tabName.value = val as string)
//   }
// )

</script>

<style lang="scss" scoped>
.w-page-tabs {
  height: 100%;
}
</style>
